/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityType } from './EntityType';
import {
    EntityTypeFromJSON,
    EntityTypeFromJSONTyped,
    EntityTypeToJSON,
    EntityTypeToJSONTyped,
} from './EntityType';
import type { ActivityEventSeverity } from './ActivityEventSeverity';
import {
    ActivityEventSeverityFromJSON,
    ActivityEventSeverityFromJSONTyped,
    ActivityEventSeverityToJSON,
    ActivityEventSeverityToJSONTyped,
} from './ActivityEventSeverity';
import type { ActivityEventType } from './ActivityEventType';
import {
    ActivityEventTypeFromJSON,
    ActivityEventTypeFromJSONTyped,
    ActivityEventTypeToJSON,
    ActivityEventTypeToJSONTyped,
} from './ActivityEventType';

/**
 * Activity event record returned by the API
 * @export
 * @interface ActivityEvent
 */
export interface ActivityEvent {
    /**
     * 
     * @type {number}
     * @memberof ActivityEvent
     */
    readonly id: number;
    /**
     * Company that owns this activity event
     * @type {number}
     * @memberof ActivityEvent
     */
    companyId: number;
    /**
     * Identifier of the service that published this event
     * @type {string}
     * @memberof ActivityEvent
     */
    publisherId: string;
    /**
     * 
     * @type {ActivityEventType}
     * @memberof ActivityEvent
     */
    type: ActivityEventType;
    /**
     * Claim ID if this is a claim-scoped event
     * @type {number}
     * @memberof ActivityEvent
     */
    claimId?: number | null;
    /**
     * 
     * @type {EntityType}
     * @memberof ActivityEvent
     */
    entityType?: EntityType;
    /**
     * ID of the entity this event relates to
     * @type {string}
     * @memberof ActivityEvent
     */
    entityId?: string | null;
    /**
     * User who performed the action
     * @type {number}
     * @memberof ActivityEvent
     */
    actorUserId?: number | null;
    /**
     * Display name of the user who performed the action
     * @type {string}
     * @memberof ActivityEvent
     */
    actorName?: string | null;
    /**
     * 
     * @type {ActivityEventSeverity}
     * @memberof ActivityEvent
     */
    severity: ActivityEventSeverity;
    /**
     * Human-readable message describing the event
     * @type {string}
     * @memberof ActivityEvent
     */
    message: string;
    /**
     * Optional structured metadata about the event
     * @type {{ [key: string]: any; }}
     * @memberof ActivityEvent
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof ActivityEvent
     */
    readonly createdAt: Date;
}



/**
 * Check if a given object implements the ActivityEvent interface.
 */
export function instanceOfActivityEvent(value: object): value is ActivityEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('publisherId' in value) || value['publisherId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('severity' in value) || value['severity'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ActivityEventFromJSON(json: any): ActivityEvent {
    return ActivityEventFromJSONTyped(json, false);
}

export function ActivityEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'publisherId': json['publisherId'],
        'type': ActivityEventTypeFromJSON(json['type']),
        'claimId': json['claimId'] == null ? undefined : json['claimId'],
        'entityType': json['entityType'] == null ? undefined : EntityTypeFromJSON(json['entityType']),
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'actorUserId': json['actorUserId'] == null ? undefined : json['actorUserId'],
        'actorName': json['actorName'] == null ? undefined : json['actorName'],
        'severity': ActivityEventSeverityFromJSON(json['severity']),
        'message': json['message'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ActivityEventToJSON(json: any): ActivityEvent {
    return ActivityEventToJSONTyped(json, false);
}

export function ActivityEventToJSONTyped(value?: Omit<ActivityEvent, 'id'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'publisherId': value['publisherId'],
        'type': ActivityEventTypeToJSON(value['type']),
        'claimId': value['claimId'],
        'entityType': EntityTypeToJSON(value['entityType']),
        'entityId': value['entityId'],
        'actorUserId': value['actorUserId'],
        'actorName': value['actorName'],
        'severity': ActivityEventSeverityToJSON(value['severity']),
        'message': value['message'],
        'metadata': value['metadata'],
    };
}

